import React from 'react';
import { Text, View } from '@react-pdf/renderer';
import { pdfStyles } from './pdfStyles';

export default function OfferPDFHeader({ order, lead, variant = 'internal', supplierName, supplierContact }) {
  if (variant === 'supplier') {
    return (
      <View style={pdfStyles.header}>
        <View>
          <View style={pdfStyles.logo}>
            <Text>CRM</Text>
          </View>
        </View>
        <View style={{ textAlign: 'right' }}>
          <Text style={pdfStyles.title}>Supplier Order {order.id}</Text>
          <Text>Date: {order.date}</Text>
          <Text style={pdfStyles.muted}>{supplierName}</Text>
          {supplierContact?.address && <Text style={pdfStyles.muted}>{supplierContact.address}</Text>}
          {supplierContact?.email && <Text style={pdfStyles.muted}>{supplierContact.email}</Text>}
          {supplierContact?.phone && <Text style={pdfStyles.muted}>{supplierContact.phone}</Text>}
          <Text style={pdfStyles.muted}>Reference: {order.id} — {order.client}</Text>
        </View>
      </View>
    );
  }
  return (
    <View style={pdfStyles.header}>
      <View>
        <View style={pdfStyles.logo}>
          <Text>CRM</Text>
        </View>
      </View>
      <View style={{ textAlign: 'right' }}>
        <Text style={pdfStyles.title}>{order.type || 'Offer'} {order.id}</Text>
        <Text>Date: {order.date}</Text>
        <Text style={pdfStyles.muted}>{order.client}</Text>
        {lead?.address && <Text style={pdfStyles.muted}>{lead.address}</Text>}
        {lead?.email && <Text style={pdfStyles.muted}>{lead.email}</Text>}
        {lead?.phone && <Text style={pdfStyles.muted}>{lead.phone}</Text>}
      </View>
    </View>
  );
}
